import { Button, Paper, Stack, Typography } from '@mui/material'
import { History20Regular, PersonVoice20Regular } from '@/components/Icon'
import siaStyles from '@/components/Settings/SiaSettingsContent.module.scss'
import { settingsRowPaperClassName } from '@/components/Settings/settingsPaperGroup'
import { SettingsRowLabelBlock } from '@/components/Settings/settingsRowLabelBlock'
import shared from '@/components/Settings/settingsShared.module.scss'

/** @param {{ voiceLabel: string }} props */
export function SiaVoiceHistoryRows({ voiceLabel }) {
  return (
    <>
      <Paper elevation={0} className={settingsRowPaperClassName({ groupPosition: 'middle' })}>
        <Stack direction={{ xs: 'column', sm: 'row' }} justifyContent="space-between" alignItems={{ xs: 'stretch', sm: 'center' }} className={shared.preferenceRowLayout}>
          <SettingsRowLabelBlock Icon={PersonVoice20Regular} title="Voice" hideDescription />
          <Stack direction="row" alignItems="center" spacing={1} className={siaStyles.voiceControls}>
            <Typography variant="body2" color="text.secondary" className={siaStyles.voiceLabel}>{voiceLabel}</Typography>
            <Button variant="outlined" size="small" className={siaStyles.selectButton}>Select…</Button>
          </Stack>
        </Stack>
      </Paper>
      <Paper elevation={0} className={settingsRowPaperClassName({ groupPosition: 'middle' })}>
        <Stack direction={{ xs: 'column', sm: 'row' }} justifyContent="space-between" alignItems={{ xs: 'stretch', sm: 'center' }} className={shared.preferenceRowLayout}>
          <SettingsRowLabelBlock Icon={History20Regular} title="Sia history" hideDescription />
          <Button variant="outlined" size="small" className={siaStyles.historyButton}>Delete Sia &amp; Dictation History…</Button>
        </Stack>
      </Paper>
    </>
  )
}
